import {
  DIALOG_TYPE_DELETE,
  LAYOUT_SET_DIALOG
} from '../store/modules/layout'

export const showDeleteDialog = (vm, data, message) => {
  vm.$store.commit({
    type: LAYOUT_SET_DIALOG,
    dialog: {
      type: DIALOG_TYPE_DELETE,
      data: data,
      message
    }
  })
}
